import React from 'react';
import { cardAnimationVariants } from '../../../../BeFi20/BeFi20.meta';
import { StepCard } from '../../../PulseCheck.styles';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { useWorkflowContext } from '../../context/useWorkflowContext';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Slider } from '../../../../CommonComponents/OPL/Slider/Slider';
import { Separator } from '../../../../CommonComponents/OPL/Separator/Separator';
import { getFulfillmentLabel } from './Fulfillment.meta';
import { COLORS } from '../../../PulseCheck.meta';
import { StepWrapper } from '../../../components/StepWrapper/StepWrapper';

export const Fulfillment = () => {
  const { categories, setCategories } = useWorkflowContext();

  const handleFulfillmentChange = (fulfillment: number, categoryIndex: number) => {
    const newCategories = categories.map((category, index) => {
      if (index === categoryIndex) {
        return {
          ...category,
          fulfillment,
        };
      }

      return category;
    });

    setCategories(newCategories);
  };

  return (
    <StepWrapper>
      <StepCard variants={cardAnimationVariants} initial="enter" animate="visible">
        <Text as="h1" fontSize="h4" fontWeight={600} textAlign="center" mb="32">
          How fulfilled are you in each of the following areas?
        </Text>

        <Box pb="16">
          {categories.map((category, index) => (
            <React.Fragment key={category.id}>
              <Box display="flex" alignItems="center" css="gap: 8px">
                <Box width={24} height={24} style={{ color: COLORS.primary }}>
                  <category.icon />
                </Box>

                <Box display="flex" flexDirection="column">
                  <Text fontSize="h6" fontWeight={600}>
                    {category.name}
                  </Text>

                  <Text color="neutral.500">{category.description}</Text>
                </Box>
              </Box>

              <Box display="flex" flexDirection="column">
                <Text fontSize="small" fontWeight={500} height={24} css="align-self: flex-end">
                  {getFulfillmentLabel(category.fulfillment)}
                </Text>

                <Slider
                  step={1}
                  min={0}
                  max={10}
                  ariaLabels={[`${category.name} Thumb`]}
                  values={[category.fulfillment]}
                  onChange={values => handleFulfillmentChange(values[0], index)}
                  showTooltip={false}
                />
              </Box>

              {index !== categories.length - 1 && <Separator mt="32" mb="16" />}
            </React.Fragment>
          ))}
        </Box>
      </StepCard>
    </StepWrapper>
  );
};
